import config from '@/config'
import axios from 'axios'

const locationToAddress = function (lat, lng) {
  return new Promise(function (resolve, reject) {
    axios.get('http://apis.map.qq.com/ws/geocoder/v1/', {
      params: {
        loaction: lat + ',' + lng,
        key: config.lbskey
      }
    }).then((res) => {
      if (res && res.status === 200) {
        const data = res.data
        if (data.status === 0) {
          resolve({
            province: data.result.address_component.province,
            city: data.result.address_component.city
          })
        } else {
          reject(res)
        }
      } else {
        reject(res)
      }
    })
    .catch(err => {
      reject(err)
    })
  })
}

export default locationToAddress



// WEBPACK FOOTER //
// ./src/utils/locationToAddress.js